<script lang="ts">
import { defineComponent, PropType } from 'vue'
import NrButton from '../NrButton/nr-button.vue'

const COMPONENT_NAME = 'NrDatepickerDay'

export default defineComponent({
  name: COMPONENT_NAME,
  components: { NrButton },
  props: {
    focus: {
      type: Boolean,
      default: false
    },
    selected: {
      type: Boolean,
      default: false
    },
    day: {
      type: Date as PropType<Date>,
      required: true
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    classnames(): (string | Record<string, boolean>)[] {
      return [
        'nr-datepicker-day',
        {
          'nr-datepicker-day--focus': this.focus
        }
      ]
    },
    variant() {
      return this.selected ? 'filled-primary' : 'minimal-neutral'
    },
    humanizeDay(): string {
      return this.day.getDate().toString()
    }
  },
  watch: {
    focus(next: boolean, prev: boolean) {
      if (!next) return
      if (next === prev) return
      this.$nextTick(() => {
        ;(this.$el as HTMLButtonElement)?.focus()
      })
    }
  }
})
</script>

<template>
  <NrButton
    :variant="variant"
    :class="classnames"
    :aria-label="`${day.toDateString()}`"
    :tabindex="focus ? 0 : -1"
    :disabled="disabled"
    v-bind="$attrs"
  >
    {{ humanizeDay }}
  </NrButton>
</template>

<style lang="scss">
.nr-datepicker-day {
  width: 100%;
}
</style>
